import { QueryClient } from "@tanstack/react-query";
import { is404Error } from "./error";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      enabled: false,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        const MAX_FAILURE_COUNT = 3;
        if (is404Error(error)) {
          return false;
        }
        return failureCount < MAX_FAILURE_COUNT;
      },
    },
  },
});
